import React, { useEffect, useMemo, useState } from "react";
import {
	Button,
	DatePicker,
	Form,
	Input,
	Radio,
	Spin,
	Row,
	InputNumber,
	Select,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory, Link } from "react-router-dom";

import saveMeter from "../../store/thunks/saveMeter";

import "./NewMeter.scss";
import useAddressFromParams from "../../hooks/useAddressFromParams";
import MeterTagField from "../../components/MeterTagField/MeterTagField";
import { useHouseMeterStatusesQuery } from "../../../HousingStock/queries/useHouseMeterStatuses";
import { useHouseMeterTariffsQuery } from "../../../HousingStock/queries/useHouseMeterTariffs";

const NewMeter = ({ form }) => {
	const {
		getFieldDecorator,
		getFieldValue,
		validateFields,
	} = form;

	const {
		params: { houseId },
	} = useRouteMatch("/Meters/newMeter/:houseId") || { params: {} };
	const [address, addressLoading] = useAddressFromParams(houseId);
	const itemLoading = useSelector((store) => store.meterStore.itemLoading);
	const meterTypes = useSelector((store) => store.meterStore.meterTypes);
  const meterStatusesQuery = useHouseMeterStatusesQuery();
  const meterTariffsQuery = useHouseMeterTariffsQuery();
	const [selectedTag, setSelectedTag] = useState(null);
	const addressInitialValue = address?.id;
	const dispatch = useDispatch();
	const history = useHistory();

  const selectedMeterTypeId = getFieldValue('MeterTypeId');
  const selectedMeterType = useMemo(() => {
    return (meterTypes || []).find((mType) => mType.id === selectedMeterTypeId);
  }, [selectedMeterTypeId, meterTypes]);
  const isMeterTypeHasTariffs = useMemo(() => {
    if (typeof selectedMeterType?.name !== 'string') {
      return false;
    }
    return selectedMeterType.name.toLowerCase() === 'электроэнергия';
  }, [selectedMeterType]);

	if (itemLoading || addressLoading) {
		return (
			<div className="meters-address-meters-spinning">
				<Spin
					style={{ minHeight: 500 }}
					size="large"
					spinning={itemLoading}
					tip="Загрузка..."
					delay={100}
				>
					<div></div>
				</Spin>
			</div>
		);
	}
	return (
		<div style={{ textAlign: "left" }}>
			<div className="address_meters-header" style={{ marginBottom: 20 }}>
				<Row className="header" type="flex">
					<span
						className="address"
						style={{ display: "inline-block", marginBottom: "10px" }}
					>
						Добавление ОДПУ по адресу {address?.addressName || ''}
					</span>
				</Row>
			</div>

			<div className="form-container">
				<Spin
					style={{ minHeight: 500 }}
					size="large"
					spinning={itemLoading}
					tip="Загрузка..."
					delay={100}
				>
					<Form
						layout="vertical"
						onSubmit={(e) => {
							e.preventDefault();
							validateFields(async (err, values) => {
								if (!err) {
									dispatch(
										saveMeter({
											...values,
											HouseId: addressInitialValue,
											TagId: selectedTag,
										})
									).then(() => {
										history.push(`/Meters/address/${addressInitialValue}`);
									});
								}
							});
						}}
					>
						<Form.Item
							label="Номер ОДПУ"
							className="meter-code-input"
						>
							{getFieldDecorator("MeterCode", {
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите номер ОДПУ",
									},
								],
							})(<Input />)}
						</Form.Item>
            <Form.Item
              label="Состояние"
              className="meter-state-select"
            >
              {getFieldDecorator('MeterStatusId', {
                rules: [
                  {
                    required: true,
                    message: 'Пожалуйста, укажите состояние ОДПУ',
                  },
                ],
              })(
                <Select
                  placeholder="Выберите состояние"
                  loading={meterStatusesQuery.isFetching}
                  showArrow
                >
                  {meterStatusesQuery.data?.map((mState) => (
                    <Select.Option
                      key={mState.id}
                      value={mState.id}
                    >
                      {mState.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
						<Form.Item
							label="Тип ОДПУ"
						>
							{getFieldDecorator("MeterTypeId", {
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите тип ОДПУ",
									},
								],
							})(
								<Radio.Group className="radio-buttons">
									{meterTypes &&
										meterTypes?.map((type) => (
											<Radio.Button key={type.name} value={type.id}>
												{type.name}
											</Radio.Button>
										))}
								</Radio.Group>
							)}
						</Form.Item>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<Form.Item
								style={{ width: "212px" }}
								label="Дата ввода в эскплуатацию"
								className="form-item"
							>
								{getFieldDecorator("CommissionningDate", {
									rules: [
									],
								})(<DatePicker style={{ width: "212px" }} />)}
							</Form.Item>

							<Form.Item
								style={{ width: "212px" }}
								className="form-item"
								label="Дата вывода из эксплуатации"
							>
								{getFieldDecorator("DecommissionningDate", {
									rules: [
									],
								})(<DatePicker style={{ width: "212px" }} />)}
							</Form.Item>
						</div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Form.Item label="Коэффициент">
                {getFieldDecorator('Coef', {
                  initialValue: 1,
                })(
                  <InputNumber
                    min={0.1}
                    step={0.1}
                  />
                )}
              </Form.Item>

              {isMeterTypeHasTariffs && (
                <>
                  <Form.Item
                    style={{
                      width: '212px',
                    }}
                    label="Тариф"
                  >
                    {getFieldDecorator('MeterTariffId', {
                      rules: [
                        {
                          required: true,
                          message: 'Пожалуйста, укажите тариф ОДПУ',
                        },
                      ],
                    })(
                      <Select
                        placeholder="Выберите тариф"
                        loading={meterTariffsQuery.isFetching}
                        showArrow
                      >
                        {meterTariffsQuery.data?.map((mTariff) => (
                          <Select.Option
                            key={mTariff.id}
                            value={mTariff.id}
                          >
                            {mTariff.name}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </>
              )}
            </div>

						<Form.Item 
							label="Расположение"
						>
							{getFieldDecorator("Description", {
								rules: [
									{
										required: true,
										message: 
											"Описание расположения не может быть пустым",
									},
									{
										max: 60,
										message:
											"Описание расположения не может быть длиннее 60 символов",
									},
								],
							})(<TextArea />)}
						</Form.Item>
						<Form.Item className="form-item">
							<MeterTagField onSelect={setSelectedTag} value={selectedTag} />
						</Form.Item>
						<div className="buttons_row">
							<Link to={`/Meters/address/${houseId}`}>
								<Button>Отмена</Button>
							</Link>
							<Button
								htmlType="submit"
								type="primary"
							>
								Сохранить
							</Button>
						</div>
					</Form>
				</Spin>
			</div>
		</div>
	);
};

export default Form.create({ name: "newMeter" })(NewMeter);
